import { useRegionals, useDeleteRegional } from 'hooks/regionals';

import {
	Button,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	useToast
} from '@chakra-ui/react';

const DeleteRegional = () => {
	const { toDelete, deleteModalOpen, setDeleteModalOpen } = useRegionals();
	const toast = useToast();

	const [deleteRegional, { loading }] = useDeleteRegional({
		onSuccess: () => {
			toast({
				title: 'Regional removida com sucesso.',
				status: 'success',
				duration: 5000,
				isClosable: true
			});
			setDeleteModalOpen(false);
		},
		onError: () => {
			toast({
				title: 'Ocorreu um erro.',
				status: 'error',
				duration: 5000,
				isClosable: true
			});
		}
	});

	const onDelete = () => {
		deleteRegional({
			variables: {
				where: {
					column: 'ID',
					operator: 'EQ',
					value: toDelete
				}
			}
		});
	};

	return (
		<Modal
			isCentered
			onClose={() => setDeleteModalOpen(false)}
			isOpen={deleteModalOpen}
			motionPreset="slideInBottom"
		>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Remover Regional</ModalHeader>
				<ModalCloseButton />
				<ModalBody>Por favor, confirme a ação de remoção.</ModalBody>
				<ModalFooter>
					<Button
						mr={3}
						variant="ghost"
						size="md"
						onClick={() => setDeleteModalOpen(false)}
					>
						Cancelar
					</Button>
					<Button
						isLoading={loading}
						colorScheme="red"
						size="md"
						onClick={() => onDelete()}
					>
						Remover
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default DeleteRegional;
